import BaseProxy from '../base-proxy';
/**
 * Class SellerProxy
 */
class SellerProxy extends BaseProxy {
  /**
   * Constructor.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('/e-invoice-api/api/seller', parameters);
    this.defaultOptions = { allowToast: false };
  }

  getSellerInformation(options = {}) {
    return this.submit('get', `${this.endpoint}/infomation`, null, { ...this.defaultOptions, ...options });
  }

  updateSellerInformation(data, options = {}) {
    return this.submit('put', `${this.endpoint}/infomation/update`, data, { ...this.defaultOptions, ...options });
  }
}

export default SellerProxy;



// WEBPACK FOOTER //
// ./src/store/proxies/e-invoice/seller-proxy.js